import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-7" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import BranchesLayout from './components/BranchesLayout.vue';
import FormSection from './FormSection.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import PageLoader from '@/components/PageLoader.vue';
import branch from "@/classes/Branch";
import AuthService from '@/classes/AuthService';
import locationService from '@/classes/LocationService';
import { ref, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
/**
 * ********************************
 * Data 
 * ********************************
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'EditPage',
  setup(__props) {

const route       = useRoute();
const loader      = ref(false)
const show        = ref(false);
const showSuccess = ref(false);
const showError   = ref(false);
const errorMsg    = ref(false);
const branchId  = ref(Number(route.params.id) as unknown as string);
const errors      = ref([]);

const provinces = ref([]);
const regions   = ref([]);
const cities    = ref([]);
const barangays = ref([]);

const form = ref({
    name         : '',
    address_line : '',
    region       : '',
    region_code  : '',
    province     : '',
    province_code: '',
    city         : '',
    city_code    : '',
    barangay     : '',
    barangay_code: '',
    zip_code     : '',
    mobile_number: '',
    start_time   : '',
    end_time     : '',
    image_path   : ''
})

/**
 * ********************************
 * Submit Form 
 * ********************************
 */
const submit = async () => {
    loader.value = true;
    const data = branch.formatData(form.value, branchId.value)

    try {
        await branch.updateBranch(branchId.value, data)
        loader.value      = false;
        show.value        = false;
        showSuccess.value = true
                
        setTimeout(() => {
            window.location.replace('/branches')
        }, 2000);
    }
    catch(error: any) {
        show.value      = false;
        showError.value = true;
        errorMsg.value  = error.response.data.message;

        if(error.response.status == 422) {
            errors.value = error.response.data.errors;
        }
        errorResponse(error)
    }
}

/**
 * ********************************
 * Methods 
 * ********************************
 */
const errorResponse = (err: any) => {
    loader.value = false

    if(err?.response.status == 401) {
        AuthService.redirectToLogin()
    }
}

const fetchAddress = () => {
        loader.value = true
        locationService.fetchRegions()
        .then((result: any) => {
            loader.value = false
            regions.value = result.data
        })
}

const fetchData = async () => {
    try {
        loader.value = true;
        const response = await branch.editBranch(branchId.value)
        loader.value = false;
        Object.assign(form.value, response.data.branch)
    }
    catch(err: any) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err.response.data.message;

        if(err.response.status == 422) {
            errors.value = err.response.data.errors;
        }
    }
}

const fetchProvince = async () => {
    loader.value = true;
    await locationService.fetchLocationData(locationService.fetchProvinces, form.value.region_code, 'Prov', provinces);
    loader.value = false;
};

const fetchCity = async () => {
    loader.value = true;
    await locationService.fetchLocationData(locationService.fetchCities, form.value.province_code, 'Mun', cities);
    loader.value = false;
};

const fetchBrgy = async () => {
    loader.value = true;
    await locationService.fetchLocationData(locationService.fetchBarangays, form.value.city_code, 'Bgy', barangays);
    loader.value = false;
};

/**
 * ********************************
 * Watchers 
 * ********************************
 */

 const watchFormValue = (value, callback) => {
    watch(
        () => form.value[value],
        (val) => {
        callback(val);
        },
        { immediate: true }
    );
}

watchFormValue("barangay_code", (val) => {
    if (val) {
        form.value.barangay = barangays.value.find((e) => e.code === val)?.label;
    }
});

watchFormValue("city_code", (val) => {
    barangays.value = [];
    if (val) {
        form.value.city = cities.value.find((e) => e.code === val)?.label;
        fetchBrgy();
    }
});

watchFormValue("province_code", (val) => {
    cities.value = [];
    barangays.value = [];
    if (val) {
        form.value.province = provinces.value.find((e) => e.code === val)?.label;
        fetchCity();
    }
});

watchFormValue("region_code", (val) => {
    cities.value = [];
    barangays.value = [];
    provinces.value = [];
    if (val) {
        form.value.region = regions.value.find((e) => e.code === val)?.label;
        fetchProvince();
  }
});

onMounted(() => {
    fetchAddress()
    fetchData()    
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Branch",
    "show-back": "",
    backUrl: "/branches"
  }, {
    default: _withCtx(() => [
      _createVNode(BranchesLayout, { "branch-id": branchId.value }, {
        contents: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(FormSection, {
              form: form.value,
              errors: errors.value,
              regions: regions.value,
              provinces: provinces.value,
              cities: cities.value,
              barangays: barangays.value,
              onClearProvince: _cache[0] || (_cache[0] = ($event: any) => (_unref(locationService).clearAddress('province', form.value))),
              onClearCity: _cache[1] || (_cache[1] = ($event: any) => (_unref(locationService).clearAddress('city', form.value))),
              onClearBgy: _cache[2] || (_cache[2] = ($event: any) => (_unref(locationService).clearAddress('barangay', form.value)))
            }, {
              default: _withCtx(() => [
                (_ctx.$hasPermission('update-branch') && _ctx.$hasPermission('update-clinic-hours'))
                  ? (_openBlock(), _createBlock(ButtonComponent, {
                      key: 0,
                      onClick: submit
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode(" Submit ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["form", "errors", "regions", "provinces", "cities", "barangays"])
          ])
        ]),
        _: 1
      }, 8, ["branch-id"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Branch",
        content: "Branch Updated Successfully!"
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Warning",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})